export const ALLOWED_CALL_EVENT_ACTION_SUB_TYPES = [
  'Terminated',
  'Paused_Mt',
  'Resumed_Mt',
  'Paused_Invalid_Face',
  'Resumed_Invalid_Face',
  'Paused_Adult_Content',
  'Resumed_Adult_Content',
];

export const CALL_EVENT_ACTION_SUB_TYPES = {
  TERMINATED: 'Terminated',
  PAUSED_MT: 'Paused_Mt',
  RESUMED_MT: 'Resumed_Mt',
  PAUSED_INVALID_FACE: 'Paused_Invalid_Face',
  RESUMED_INVALID_FACE: 'Resumed_Invalid_Face',
  PAUSED_ADULT_CONTENT: 'Paused_Adult_Content',
  RESUMED_ADULT_CONTENT: 'Resumed_Adult_Content',
};

export const ALLOWED_CALL_EVENT_EVENT_SUB_TYPES = [
  'App_To_Background',
  'App_To_Foreground',
  'Face_Left',
  'Face_Entered',
  'Too_Many_Faces',
  'Identity_Check',
  'Adult_Content_Check',
  'Adult_Content_Alert',
  'Invalid_Face_Alert',
  'Prisoner_Joined',
  'Prisoner_Left',
  'Visitor_Joined',
  'Visitor_Left',
  'Pre_Call_Security',
  'Master_Terminal_Monitor_Start',
  'Master_Terminal_Monitor_End',
  'Master_Terminal_Note',
  'Visitor_Camera_Flip',
  'Visitor_Screen_Shot',
  'Visitor_Screen_Recording',
  'Call_Security_Joined',
  'Call_Security_To_Off',
  'Call_Security_To_Low',
  'Call_Security_To_Medium',
  'Call_Security_To_High',
  'Call_Security_To_Max',
  'Adult_Content_To_Off',
  'Adult_Content_To_Alert',
  'Adult_Content_To_Pause',
  'Banner_Shown_Invalid_Face_Pause',
  'Banner_Shown_Invalid_Face_Alert',
  'Banner_Shown_Adult_Content',
  'Banner_Shown_Adult_Content_Alert',
  'Banner_Dismissed_Invalid_Face_Pause',
  'Banner_Dismissed_Invalid_Face_Alert',
  'Banner_Dismissed_Adult_Content_Pause',
  'Banner_Dismissed_Adult_Content_Alert',
  'New_Chat_Message',
  'Hand_Raised',
  'Hand_Raise_Acknowledged',
  'Prisoner_Adult_Content_Alert',
  'Prisoner_Invalid_Face_Alert',
  'Prisoner_Pre_Call_Security',
  'Soft_Pause_Invalid_Face',
  'Soft_Pause_Too_Many_Faces',
  'Soft_Pause_Adult_Content',
  'Soft_Pause_Resumed',
  'Prisoner_Soft_Pause_Invalid_Face',
  'Prisoner_Soft_Pause_Too_Many_Faces',
  'Prisoner_Soft_Pause_Adult_Content',
  'Prisoner_Soft_Pause_Resumed',
];

export const CALL_EVENT_EVENT_SUB_TYPES = {
  APP_TO_BACKGROUND: 'App_To_Background',
  APP_TO_FOREGROUND: 'App_To_Foreground',
  FACE_LEFT: 'Face_Left',
  FACE_ENTERED: 'Face_Entered',
  TOO_MANY_FACES: 'Too_Many_Faces',
  IDENTITY_CHECK: 'Identity_Check',
  ADULT_CONTENT_CHECK: 'Adult_Content_Check',
  ADULT_CONTENT_ALERT: 'Adult_Content_Alert',
  PRISONER_ADULT_CONTENT_ALERT: 'Prisoner_Adult_Content_Alert',
  INVALID_FACE_ALERT: 'Invalid_Face_Alert',
  PRISONER_INVALID_FACE_ALERT: 'Prisoner_Invalid_Face_Alert',
  PRISONER_JOINED: 'Prisoner_Joined',
  PRISONER_LEFT: 'Prisoner_Left',
  VISITOR_JOINED: 'Visitor_Joined',
  VISITOR_LEFT: 'Visitor_Left',
  PRE_CALL_SECURITY: 'Pre_Call_Security',
  PRISONER_PRE_CALL_SECURITY: 'Prisoner_Pre_Call_Security',
  MASTER_TERMINAL_MONITOR_START: 'Master_Terminal_Monitor_Start',
  MASTER_TERMINAL_MONITOR_END: 'Master_Terminal_Monitor_End',
  MASTER_TERMINAL_NOTE: 'Master_Terminal_Note',
  VISITOR_CAMERA_FLIP: 'Visitor_Camera_Flip',
  VISITOR_SCREEN_SHOT: 'Visitor_Screen_Shot',
  VISITOR_SCREEN_RECORDING: 'Visitor_Screen_Recording',
  CALL_SECURITY_JOINED: 'Call_Security_Joined',
  CALL_SECURITY_TO_OFF: 'Call_Security_To_Off',
  CALL_SECURITY_TO_LOW: 'Call_Security_To_Low',
  CALL_SECURITY_TO_MEDIUM: 'Call_Security_To_Medium',
  CALL_SECURITY_TO_HIGH: 'Call_Security_To_High',
  CALL_SECURITY_TO_MAX: 'Call_Security_To_Max',
  ADULT_CONTENT_TO_OFF: 'Adult_Content_To_Off',
  ADULT_CONTENT_TO_ALERT: 'Adult_Content_To_Alert',
  ADULT_CONTENT_TO_PAUSE: 'Adult_Content_To_Pause',
  BANNER_SHOWN_INVALID_FACE_PAUSE: 'Banner_Shown_Invalid_Face_Pause',
  BANNER_SHOWN_INVALID_FACE_ALERT: 'Banner_Shown_Invalid_Face_Alert',
  BANNER_SHOWN_ADULT_CONTENT_PAUSE: 'Banner_Shown_Adult_Content',
  BANNER_SHOWN_ADULT_CONTENT_ALERT: 'Banner_Shown_Adult_Content_Alert',
  BANNER_DISMISSED_INVALID_FACE_PAUSE: 'Banner_Dismissed_Invalid_Face_Pause',
  BANNER_DISMISSED_INVALID_FACE_ALERT: 'Banner_Dismissed_Invalid_Face_Alert',
  BANNER_DISMISSED_ADULT_CONTENT_PAUSE: 'Banner_Dismissed_Adult_Content_Pause',
  BANNER_DISMISSED_ADULT_CONTENT_ALERT: 'Banner_Dismissed_Adult_Content_Alert',
  SOFT_PAUSE_INVALID_FACE: 'Soft_Pause_Invalid_Face',
  SOFT_PAUSE_TOO_MANY_FACES: 'Soft_Pause_Too_Many_Faces',
  SOFT_PAUSE_TOO_FEW_FACES: 'Soft_Pause_Too_Few_Faces',
  SOFT_PAUSE_ADULT_CONTENT: 'Soft_Pause_Adult_Content',
  SOFT_PAUSE_RESUMED: 'Soft_Pause_Resumed',
  PRISONER_SOFT_PAUSE_INVALID_FACE: 'Prisoner_Soft_Pause_Invalid_Face',
  PRISONER_SOFT_PAUSE_TOO_MANY_FACES: 'Prisoner_Soft_Pause_Too_Many_Faces',
  PRISONER_SOFT_PAUSE_TOO_FEW_FACES: 'Prisoner_Soft_Pause_Too_Few_Faces',
  PRISONER_SOFT_PAUSE_ADULT_CONTENT: 'Prisoner_Soft_Pause_Adult_Content',
  PRISONER_SOFT_PAUSE_RESUMED: 'Prisoner_Soft_Pause_Resumed',
  NEW_CHAT_MESSAGE: 'New_Chat_Message',
  HAND_RAISED: 'Hand_Raised',
  HAND_RAISE_ACKNOWLEDGED: 'Hand_Raise_Acknowledged',
};
